module.exports = __webpack_public_path__ + "static/featuredBlockLayout4Front-24e63d7a9bb208dddb470a5125ca96f8.png";